<!--
  CMMS-specific roles preview shown at the top of the user menu. Lives in the app (not the design
  system) because the role model is a CMMS concept. Collapses back to the preview when the menu closes.
-->
<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons'

const props = defineProps<{ roles: string[]; isOpen: boolean }>()

const ROLES_PREVIEW = 3
const showAll = ref(false)

const visibleRoles = computed(() =>
  showAll.value ? props.roles : props.roles.slice(0, ROLES_PREVIEW),
)

watch(
  () => props.isOpen,
  (open) => {
    if (!open) showAll.value = false
  },
)
</script>

<template>
  <div class="select-none px-4 py-3 border-b border-border min-w-0">
    <div v-if="roles.length" class="flex flex-col gap-2">
      <div class="text-xs uppercase tracking-wide text-content-subtle">ROLES ({{ roles.length }})</div>
      <div class="flex flex-col gap-1">
        <span v-for="role in visibleRoles" :key="role" class="text-xs">
          {{ role.toLocaleUpperCase() }}
        </span>
      </div>
      <button
        v-if="roles.length > ROLES_PREVIEW"
        type="button"
        class="flex w-fit cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-xs text-content-subtle hover:text-content"
        data-testid="app-header-roles-toggle"
        @click.stop="showAll = !showAll"
      >
        <span>{{ showAll ? 'View less' : 'View more' }}</span>
        <FontAwesomeIcon :icon="showAll ? faChevronUp : faChevronDown" class="text-xs" />
      </button>
    </div>
  </div>
</template>
